/**
 * Route for `creator-drilldown`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CreatorDrilldownPage } from "../features/creator-drilldown/CreatorDrilldownPage";

export const creatorDrilldownRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/creator-drilldown",
	component: CreatorDrilldownPage,
});

export default creatorDrilldownRoute;
